module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-Medium.e3a6d758.woff2";